const adminRoutes = {
	name: 'admin',
	path: '/admin',
	redirect: { name: 'admin.general' },
	meta: { requiresAuth: true, permissions: ['admin.index'] },
	component: () => import('#modules/admin/AdminModule.vue'),
	children: [
		{
			name: 'admin.general',
			path: 'general',
			component: () => import('#modules/admin/pages/AdminGeneral.vue'),
		},
		{
			name: 'admin.actions',
			path: 'actions',
			component: () => import('#modules/admin/pages/AdminActions.vue'),
		},
		{
			name: 'admin.suppliers',
			path: 'suppliers',
			component: () => import('#modules/admin/pages/AdminSuppliers.vue'),
		},
		{
			name: 'admin.registrations',
			path: 'registrations',
			component: () => import('#modules/admin/pages/AdminRegistrations.vue'),
		},
		{
			name: 'admin.manuals',
			path: 'manuals',
			component: () => import('#modules/admin/pages/AdminManuals.vue'),
		},
		{
			name: 'admin.sensory',
			path: 'sensory',
			component: () => import('#modules/admin/pages/AdminSensory.vue'),
		},
		{
			name: 'admin.login',
			path: 'login',
			redirect: { name: 'admin.login.index' },
			children: [
				{
					name: 'admin.login.index',
					path: '',
					component: () => import('#modules/admin/pages/AdminLoginIndex.vue'),
				},
				{
					name: 'admin.login.create',
					path: 'create',
					component: () => import('#modules/admin/pages/AdminLoginForm.vue'),
					props: { isNew: true, isEdit: true },
				},
				{
					name: 'admin.login.show',
					path: ':ssoId(\\d+)',
					component: () => import('#modules/admin/pages/AdminLoginForm.vue'),
					props: { isNew: false, isEdit: false },
				},
				{
					name: 'admin.login.edit',
					path: ':ssoId(\\d+)/edit',
					component: () => import('#modules/admin/pages/AdminLoginForm.vue'),
					props: { isNew: false, isEdit: true },
				},
			],
		},
		{
			name: 'admin.dashboard',
			path: 'dashboard',
			redirect: { name: 'admin.dashboard.index' },
			children: [
				{
					name: 'admin.dashboard.index',
					path: '',
					component: () => import('#modules/admin/pages/DashboardTilesIndex.vue'),
				},
				{
					name: 'admin.dashboard.create',
					path: 'create',
					component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
					props: { isNew: true, isEdit: true },
				},
				{
					name: 'admin.dashboard.show',
					path: ':tileId(\\d+)',
					component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
					props: { isNew: false, isEdit: false },
				},
				{
					name: 'admin.dashboard.edit',
					path: ':tileId(\\d+)/edit',
					component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
					props: { isNew: false, isEdit: true },
				},
			],
		},
	],
}

export default adminRoutes
